import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchQuestHistory, clearQuestHistory } from '../../../actions/quest'
import HistoryList from '../questhistory/HistoryList'
import { postLoggingInfo } from '../../../actions/logging'
import { getQuestEventLoggingData } from '../../../utils/logging'

class QuestHistory extends React.Component {
  componentDidMount() {
    const { quest } = this.props
    this.props.dispatch(fetchQuestHistory(1, true))
    const loggingData = getQuestEventLoggingData(quest)
    const data = {
      ...loggingData,
      action: 'view_history'
    }
    this.props.dispatch(postLoggingInfo('quest', data))
  }

  componentWillUnmount() {
    this.props.dispatch(clearQuestHistory())
  }

  render() {
    if (
      this.props.isFetchingQuestHistory &&
      this.props.quest_events.length === 0
    ) {
      return <div className="loading" />
    }
    return (
      <HistoryList
        events={this.props.quest_events}
        dispatch={this.props.dispatch}
        page={this.props.page}
        total={this.props.total}
        isFetchingQuestHistory={this.props.isFetchingQuestHistory}
        quest={this.props.quest}
      />
    )
  }
}

export const mapStateToProps = state => ({
  quest_events: state.quest.quest_events,
  page: state.quest.historyPage,
  total: state.quest.historyTotal,
  isFetchingQuestHistory: state.quest.isFetchingQuestHistory,
  quest: state.quest.item
})

QuestHistory.propTypes = {
  quest_events: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  isFetchingQuestHistory: PropTypes.bool.isRequired,
  quest: PropTypes.object.isRequired
}

export default connect(mapStateToProps)(QuestHistory)
export { QuestHistory as QuestHistoryDisconnected }



// WEBPACK FOOTER //
// ./src/components/quest/section/QuestHistory.js